export const UAM_ADMIN_ROLE = "UAM_ADMIN";
export const SOP_KO_BOTTLER_ADMIN_ROLE = "SOP-KO-BOTTLER-ADMIN";

export const hasRole = (roles = [], requiredRole = "") =>
  Boolean(requiredRole) && Array.isArray(roles) && roles.includes(requiredRole);

export const hasUamAdminAccess = (roles = []) =>
  hasRole(roles, UAM_ADMIN_ROLE);

export const hasSopKoBottlerAdminAccess = (roles = []) =>
  hasRole(roles, SOP_KO_BOTTLER_ADMIN_ROLE);
